export default __webpack_public_path__ + "static/media/adPlay.b5975ae5.png";